import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';

import shape1 from './svg/shape-1.svg';
import shape2 from './svg/shape-2.svg';
import dotPattern from './svg/dot-pattern.svg';

import styles from './home-banner.module.scss';

const cx = classNames.bind(styles);

const HomeBanner = ({ title, description, buttontext = null, buttonurl = null }) => (
  <section className={cx('container', 'wrapper')}>
    <div className={cx('inner')}>
      <Heading className={cx('title')} tag="h2" color="tertiary">
        {title}
      </Heading>
      <p className={cx('description')}>{description}</p>
      {buttontext && buttonurl && (
        <Button className={cx('button')} to={buttonurl}>
          {buttontext}
        </Button>
      )}

      <img className={cx('shape-1')} src={shape1} aria-hidden alt="" width="386" height="316" />
      <img className={cx('shape-2')} src={shape2} aria-hidden alt="" width="396" height="344" />
      <img
        className={cx('dot-pattern')}
        src={dotPattern}
        aria-hidden
        alt=""
        width="145"
        height="96"
      />
    </div>
  </section>
);

HomeBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttontext: PropTypes.string,
  buttonurl: PropTypes.string,
};

export default HomeBanner;
